import { authQueryOptions } from '../auth/queries'
import type { GameCreationParams, GetGameResponse } from '@/tygo/dto'
import type { Game, GetAvailableGamesRow, JoinGameRow } from '@/tygo/db'
import { apiFetch } from '@/lib/http'
import { getQueryClient } from '@/integrations/tanstack-query/root-provider'

const GAME_BASE = '/api/v1/game'

export function createGame(params: GameCreationParams) {
  const authData = getQueryClient().getQueryData(authQueryOptions('').queryKey)
  const accessToken = authData?.access_token

  return apiFetch<Game>(`${GAME_BASE}`, {
    method: 'POST',
    body: JSON.stringify(params),
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  })
}

export function getAvailableGames() {
  return apiFetch<Array<GetAvailableGamesRow>>(`${GAME_BASE}/available`)
}

export function joinGame(gameId: string, buyInAmount: number) {
  const authData = getQueryClient().getQueryData(authQueryOptions('').queryKey)
  const accessToken = authData?.access_token

  return apiFetch<JoinGameRow>(`${GAME_BASE}/join`, {
    method: 'POST',
    body: JSON.stringify({ game_id: gameId, buy_in_amount: buyInAmount }),
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  })
}

export function leaveGame(gameId: string) {
  const authData = getQueryClient().getQueryData(authQueryOptions('').queryKey)
  const accessToken = authData?.access_token

  return apiFetch<void>(`${GAME_BASE}/leave`, {
    method: 'POST',
    body: JSON.stringify({ game_id: gameId }),
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  })
}

export function getGame(gameId: string) {
  const authData = getQueryClient().getQueryData(authQueryOptions('').queryKey)
  const accessToken = authData?.access_token

  return apiFetch<GetGameResponse>(`${GAME_BASE}?game_id=${gameId}`, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  })
}
